/*
 * Anchors 
 */
var AnchorController = (function ($) {
  
  var doc;
  
  function ready() {
    doc = $(document.body);
    doc.on('click', '.disabled,[disabled]', onDisabledClick);
  }
  
  // On disabled click, prevent any action.
  function onDisabledClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  
  /* 
   * Generate navigation by looking for items that match the given selector.
   */
  function generate(selector) {
    selector = selector || 'h1,h2,h3,h4,h5,h6,p';
    var items = $(selector, '#main'),
        ul = $("<ul />");
    
    items.each(function () {
      var item = $(this);
      if (!item.attr('id')) return;
      
      var li = $("<li><a /></li>"),
          a = li.children('a');
      
      var href = '#' + item.attr('id');
      a[0].href = href;
      a.attr('data-scroll-to', href);
      a.html(item.html());
      ul.append(li);
    });
    
    return ul;
  }
  
  $(ready);
  
  // return {
  //   generate: generate
  // };
  
})(jQuery);